import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Footer=()=> {
  return (
    <footer className="py-8 px-4 relative bg-gradient-to-t from-slate-900 to-transparent">
      <div className="relative z-10 max-w-6xl mx-auto text-center">
        <motion.div
          initial={{y: 30,opacity: 0}}
          whileInView={{y: 0,opacity: 1}}
          transition={{duration: 0.8}}
          viewport={{once: true}}
        >
          <div className="mb-4">
            <img 
              src="https://static.wixstatic.com/media/4fbfa6_be75bd70432e4b5aa62c8555bb24df83~mv2.png" 
              alt="fengshuiX Logo" 
              className="w-24 md:w-32 h-auto mx-auto mb-4 drop-shadow-[0_0_8px_rgba(236,72,153,0.3)]"
            />
          </div>
          <p className="text-lg text-gray-300 font-medium">
            จัดสอนโดย 
          </p>
          <h3 className="text-xl md:text-2xl font-bold text-white mb-2">
            อาจารย์รวิ อัญญากาญจน์
          </h3>
          <p className="text-lg text-pink-400 font-semibold">
            fengshuiX
          </p>
          
          <div className="mt-6 pt-6 border-t border-slate-700/50">
            <p className="text-gray-400 text-sm">
              © 2024 Bazi Love & Relationships. All rights reserved.
            </p>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;